import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { MarkdownComponent, TypographyComponent } from '@hyperkit'

@Component({
  standalone: true,
  selector: 'shared-response-actions',
  imports: [CommonModule, MarkdownComponent, TypographyComponent],
  templateUrl: './response-actions.component.html',
  styleUrls: ['./response-actions.component.scss'],
})
export class ResponseActionsComponent {
  @Input() analystRunbook = ''
  @Input() mitigationRecommendations = ''
  @Input() playbook = ''
}
